import ccEcharts from '@/components/common/echarts/echarts-base.vue';
import echarts from 'echarts';
export default {
    name: 'bar-portrait-echarts',
    components: {ccEcharts},
    props: {
        id: {
            type: String,
            default: ''
        },
        data:{
            type:Array,
            default() {
                return [];
            }
        }
    },
    watch: {
        data: {
            deep: true,
            handler: function (val) {
                this.echartsData = val;
                this.initOptions();
                // this.handleData();
            }
        }
    },
    data() {
        return {
            echartsData:this.data,
            options:{
                grid:{
                    left:'15%',
                    top:'10%',
                    bottom:'15%',
                    right:'24%'
                },
                xAxis: {
                    type: 'value',
                    axisTick: {show: false},
                    axisLine: {show: false},
                    axisLabel: {
                        show: true,
                        margin: 50,
                        align: 'center',
                        textStyle: {
                            fontSize: 16,
                            color: '#40444d'
                        }
                    },
                    interval: 0
                },
                yAxis: {
                    type: 'category',
                    splitLine: {show: false},
                    axisTick: {show: false},
                    axisLine: {show: false},
                    axisLabel: {
                        show: true,
                        margin: 40,
                        align: 'center',
                        textStyle: {
                            fontSize: 16,
                            color: '#40444d'
                        }
                    }
                },
                series: [{
                    type: 'bar',
                    label: {
                        show: true,
                        position: 'right',
                        fontSize: 16
                    },
                    itemStyle: {
                        normal: {
                            color: function () {
                                return new echarts.graphic.LinearGradient(
                                    1, 0, 0, 0,
                                    [{
                                        offset: 1,
                                        color: '#54B1FE '
                                    },
                                    {
                                        offset: 0,
                                        color: '#0B73EC'
                                    }
                                    ]
                                );
                            },
                            barBorderRadius: 8
                        }
                    },
                    silent: true,
                    barWidth: 15,
                    data: []
                }]
            }
        };
    },
    mounted() {
        this.handleData();
    },
    methods: {
        // 处理options的data
        handleData() {
            this.initOptions();
        },
        // 处理options
        initOptions() {
            const _this = this;
            const yAxisData = [];
            _this.echartsData.forEach(item => {
                yAxisData.push(item.name);
            });
            this.options.yAxis.data = yAxisData;
            this.options.series.forEach(item => {
                item.data = _this.echartsData;
            });
        }

    }
};
